import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../App.css";
import { Route, Routes, Navigate } from "react-router-dom";

import routes from "../routes";

function Admin() {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <div className="wrapper">
      <Sidebar />
      <Header />
      <div className="page-wrapper">
        <Routes>
          {getRoutes(routes)}
          <Route
            path="*"
            element={<Navigate to="/admin/dashboard" replace />}
          />
        </Routes>
      </div>
      <div className="overlay toggle-btn-mobile"></div>
      <a href="#section" className="back-to-top">
        <i className="bx bxs-up-arrow-alt"></i>
      </a>
      <Footer />
    </div>
  );
}

export default Admin;
